import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-break",
  "use": "icon-break-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-break\"><path d=\"M528 432V288h64v144H736v64h-144V640h-64v-144H384v-64h144z m96.992-15.968l-23.584-21.6 287.04-313.44 23.584 21.6-287.04 313.44z m-129.568 89.344l23.2 22.08-374.08 393.472-23.168-22.08 374.08-393.472zM512 736h416v160H512v-160z m32 32v96h352v-96H544z\" p-id=\"2029\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol